import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { HabaActiveCartService } from '@app/services';
import { SemanticPathService } from 'haba-core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HabaCartValidationGuard {
  constructor(
    protected habaActiveCartService: HabaActiveCartService,
    protected semanticPathService: SemanticPathService,
    protected router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([
      this.habaActiveCartService.getActive(),
      this.habaActiveCartService.isStable(),
    ]).pipe(
      filter(([_, loaded]) => loaded),
      switchMap(() => this.habaActiveCartService.takeIsValidCart()),
      map((isValid) => {
        if (!isValid) {
          console.log('Cart invalid, redirecting to cart page');
          return this.router.parseUrl(this.semanticPathService.get('cart'));
        }
        return true;
      })
    );
  }
}
